const STORAGE_KEY = "hwms-company-info";
export const COMPANY_INFO_EVENT = "company-info-updated";

export const DEFAULT_COMPANY_INFO = {
  name: "High Window Medical Services",
  address: ["Hawali, Block 8, Surqah bin Malik Street, Floor 2,", "Office 22.", "Kuwait City, Kuwait."].join("\n"),
  email: "Info@highwindow-kwt.com",
  phone: "+965-90044801",
};

const isBrowser = () => typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const getSavedCompanyInfo = () => {
  if (!isBrowser()) {
    return { ...DEFAULT_COMPANY_INFO };
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_COMPANY_INFO };
    const parsed = JSON.parse(raw);
    return {
      ...DEFAULT_COMPANY_INFO,
      ...parsed,
      address: typeof parsed.address === "string" && parsed.address.trim().length ? parsed.address : DEFAULT_COMPANY_INFO.address,
      name: typeof parsed.name === "string" && parsed.name.trim().length ? parsed.name : DEFAULT_COMPANY_INFO.name,
      email: typeof parsed.email === "string" && parsed.email.trim().length ? parsed.email : DEFAULT_COMPANY_INFO.email,
      phone: typeof parsed.phone === "string" && parsed.phone.trim().length ? parsed.phone : DEFAULT_COMPANY_INFO.phone,
    };
  } catch (err) {
    console.error("Unable to parse stored company info", err);
    return { ...DEFAULT_COMPANY_INFO };
  }
};

export const saveCompanyInfo = (info) => {
  if (!isBrowser()) return false;
  const normalized = {
    name: (info?.name || "").trim(),
    address: (info?.address || "").split(/\r?\n/).map((line) => line.trim()).filter(Boolean).join("\n"),
    phone: (info?.phone || "").trim(),
    email: (info?.email || "").trim(),
  };
  const toPersist = {
    ...DEFAULT_COMPANY_INFO,
    ...normalized,
  };
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(toPersist));
    window.dispatchEvent(new Event(COMPANY_INFO_EVENT));
    return true;
  } catch (err) {
    console.error("Unable to save company info", err);
    return false;
  }
};

export const splitAddressLines = (address) => {
  if (typeof address !== "string" || !address.trim()) {
    return DEFAULT_COMPANY_INFO.address.split(/\r?\n/).concat(["", "", ""]).slice(0, 3);
  }
  const cleaned = address
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);
  return cleaned.concat(["", "", ""]).slice(0, 3);
};

export const COMPANY_INFO_STORAGE_KEY = STORAGE_KEY;

